export const EVENT_LIST_REQUEST = "EVENT_LIST_REQUEST"
export const EVENT_LIST_SUCCESS = "EVENT_LIST_SUCCESS"
export const EVENT_LIST_FAIL = "EVENT_LIST_FAIL"